import { useSupabaseClient } from '~/plugins/supabase';

export default defineNuxtPlugin(() => {
  const supabase = useSupabaseClient();

  // ✅ 1. Get session immediately when app loads
  supabase.auth.getSession().then(({ data }) => {
    if (data.session) {
      localStorage.setItem('session', JSON.stringify(data.session));
    } else {
      localStorage.removeItem('session');
    }
  });

  // ✅ 2. Listen for login/logout/refresh events
  supabase.auth.onAuthStateChange((_event, session) => {
    if (session) {
      localStorage.setItem('session', JSON.stringify(session));
    } else {
      localStorage.removeItem('session');
    }
  });

  // ✅ 3. Refresh every 30 minutes to keep token alive
  setInterval(
    async () => {
      const { data, error } = await supabase.auth.refreshSession();
      if (!error && data.session) {
        localStorage.setItem('session', JSON.stringify(data.session));
      }
    },
    30 * 60 * 1000
  );
});
